module.exports = __webpack_public_path__ + "img/icons_Prancheta 1-161.4bae3155.svg";